module.exports = __webpack_public_path__ + "78bcb856dc57b19b0d36b88b03dca600.svg";